module.exports = __webpack_public_path__ + "img/logo2.260be666.png";